"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
var _helpers = require("../../../react-organisms/SVBAPICards/src/js/helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SVBCTABlock Component
 * By Dharma Adusumilli <dadusumilli@svb.com> (www.svb.com)
 * Summary
 * to render a CTA block
 */
const SVBCTABlock = props => {
  const {
    title,
    content,
    secondaryButton,
    primaryButton,
    extraClasses,
    secondaryUrl,
    primaryUrl,
    color
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: color === 'none' ? 'ctablock-card-white' : 'ctablock-card'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ctablock-content px-4 mx-2"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "heading-large",
    variant: "ctablock-header"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "blue-line"
  }), /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "paragraph",
    variant: "ctablock-text"
  }, content), /*#__PURE__*/_react.default.createElement("div", {
    className: "ctablock-actions"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    text: secondaryButton,
    size: "large",
    style: "secondary",
    state: "default",
    type: "text",
    onClick: () => window.location.href = secondaryUrl,
    dataTestid: (0, _helpers.slugCreator)('button-' + secondaryButton)
  }), /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    text: primaryButton,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "right-arrow",
    iconSide: "right",
    onClick: () => window.location.href = primaryUrl,
    extraClasses: extraClasses,
    dataTestid: (0, _helpers.slugCreator)('button-' + primaryButton)
  }))));
};
var _default = exports.default = SVBCTABlock;